import React from "react";
import { useTranslation } from "react-i18next";
import { ProductItemComponentProps } from "../../constants/interface.ts";

const TaglineComponent = (props: ProductItemComponentProps) => {
    const { title = '', paragraph = '', img = '', imgClass = '' } = props;
    const {t} = useTranslation();

    return (
        <div className="grid gap-8 lg:gap-16">
            <div className="flex flex-wrap justify-between gap-6 md:flex-nowrap lg:gap-16">
                <p className="text-3xl font-bold text-black-1A1 lg:text-4xl lg:max-w-[30rem]">{t(title)}</p>
                <p className="text-base font-normal text-gray-535 lg:max-w-[30rem]">{t(paragraph)}</p>
            </div>
            <img loading="lazy" src={img} alt=""
                className={`w-full h-[26.75rem] rounded-lg bg-gray-DDE one ${imgClass && imgClass}`}
            />
        </div>
    );
};

export default TaglineComponent;